<template>
<el-card shadow="never" style="width:600px;">
  
</el-card>
</template>

<script>
export default {
    props: {
        handleAuthLink: {
            type: Function
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.loading-container {
    padding: 30px;
    text-align: center;
}
</style>
